import React, { Component } from 'react';
import "./event.css"
import   SideNav from "../sidenav/sidenav.js"
import  AuthService  from "../api/authentication.js";
import  Moble from "../sidenav/moble.js"
import moment from 'moment';
import { DatetimePicker, DatetimePickerTrigger, DatetimeRangePicker  } from 'rc-datetime-picker';
import 'rc-datetime-picker/dist/picker.css';
// import "rc-datetime-picker/dist/rc-datetime-picker.js"
// game
// import "rc-datetime-picker/dist/rc-datetime-picker.js"
import axios from 'axios' 
import {
  Redirect
} from 'react-router-dom'
import Ticket from '../build/ticket';
  var Auth =  new AuthService();
  //   https://uvune-events.herokuapp.com
class Eventcreate extends Component {

  constructor(props){
    super(props)
    this.state = {
        loading : false,
        noerorrpage :  true,
        domain: 'https://uvune-events.herokuapp.com',
        file: '',
        imagePreviewUrl: '', 
        imagePreviewUrlticket: '',
        ticket  : false   ,
        imageurl:false,
        ifImagenull:false,
        form:true,
        moment: moment(),
        isActive : false 
    }

  }

  
  componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)

    this.setState({
      isActive:true
    })
  }



  //  _handleSubmit(e) {
  //   e.preventDefault();
  //   // TODO: do something with -> this.state.file
  //   console.log('handle uploading-', this.state.file);
  // }

  _handleImageChange(e) {

    e.preventDefault();
    this.setState({
      // loading:true
  })
    let reader = new FileReader();
    let file = e.target.files[0];
    

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
        form:true,
        ifImagenull : true
      });
    }

    reader.readAsDataURL(file)
  }

  _handleImageticket=(e)=>{
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    // console.log("file data", file)

    reader.onloadend = () => {
      this.setState({
        imagePreviewUrlticket:file,
        imagePreviewUrl: reader.result,
        form:false,
        ifImagenull : true
      });
    }

    reader.readAsDataURL(file)
  }

  showTicket=(event)=>{
    event.preventDefault()
    this.setState({
      ticket : true
    })

  }

  _handleSubmitform=(e)=>{
    e.preventDefault();
      this.setState({
          loadingTerms:true,
          loading:true
      })
      const datapayment ={
        type : "FM",
        name : this.name.value,
        description : this.description.value,
        amount : this.amount.value,
        venue: this.valueTK.value,
        owner: this.props.user._id,
        organizers_id : this.props.organizer._id, 
        date:this.state.moment._d
    }

  const requestOptions = {
    method: 'POST', 
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    body: JSON.stringify(datapayment),
  };
  fetch(this.state.domain+"/payment-item", requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                // console.log("result form data", result)

            if(this.state.ifImagenull){
              this.data(result)
            }else{
              this.props.history.replace({
                pathname: '/events/'+ result._id,
                // state: { detail: res}
                state: { notice: "true" , message:"Create Event" }
              })
            }
               
                // console.log("date", result.createdAt)
                this.setState({

                    loading:false,
                    noticeshow:true,
                    noticeMassage : "Created"
                })
              
            }
          
        }).catch( (error) => {
        });

        this.setState({
            loading:false ,
            noticeMassage : "Failed to create"
        })  
        this.timeout() 


  }

  
  _handleSubmit=(e)=> {
    e.preventDefault();
      this.setState({
          loadingTerms:true,
          loading:true
      })

      const datapayment ={
        type : "TK",
        name : this.name.value,
        description : this.description.value,
        amount : this.amount.value,
        venue: this.valueTK.value,
        owner: this.props.user._id,
        organizers_id : this.props.organizer._id, 
        data:this.state.moment._d
    }

  const requestOptions = {
    method: 'POST', 
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    body: JSON.stringify(datapayment),
  };
  fetch(this.state.domain+"/payment-item", requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
              if(this.state.ifImagenull){
                this.data(result)
              }else{
                this.props.history.replace({
                  pathname: '/events/'+ result._id,
                  // state: { detail: res}
                  state: { notice: "true" , message:"Create Event" }
                })
             }
                this.setState({

                    loading:false,
                    noticeshow:true,
                    noticeMassage : "Created"
                })
              
            }
          
        }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });

        this.setState({
            loading:false ,
            noticeMassage : "Failed to create"
        })  
        this.timeout() 
  }

  data=(data)=>{
    // console.log("result form data id", data._id)
    // console.log("jdtbgkhjsdtg------>image",this.state.image)
    // console.log("data ----===>", data._id)
  const formData = new FormData();

    if(this.state.form){
      // console.log("true")
      formData.append('uri', this.state.file)
    }else{
      // console.log("false")
      formData.append('uri', this.state.imagePreviewUrlticket)
    }
  
    // formData.append('uri', this.state.file)
    //  console.log("file upload.....",this.state.file, "file upload ticket", this.state.imagePreviewUrlticket)
    formData.append('featured_image', true);
    formData.append('payment_item_id',  data._id);

    const options = {
        method: 'POST',
        headers: { 
            'content-type': 'multipart/form-data',
        'access-control-allow-origin': '*',
        'Authorization': Auth.getToken(), 
        },
        url:this.state.domain+"/upload-logo",
    };
        // console.log("options ----====>",options )
        axios.post(options.url, formData, options.headers)
          .then(res => {
            if(res){
              // console.log("data----->image", res)
              if(res.status === 201)
              // console.log("data----->image3", res)
              // this.props.history.replace(`/info/&{dgm}`);
              this.props.history.replace({
                pathname: '/events/'+ data._id,
                // state: { detail: res}
                state: { notice: "true" , message:"Create Event" }
              })
                this.setState({
                    termsError : true,
                    termsMS : "Upload successful",
                    loadingTerms:false,
                    Ifterms :false
                })
           
         }
           
           this.timeout()
          }).catch( (error) => {
            //    console.log("error==------>",error)
               this.setState({
                 termsError : true,
                 termsMS : "Image to large",
                 loadingTerms:false,
                 Ifterms :false
               })
               this.timeout()
         });

  }

  timeout() {
    setTimeout(function() {
        this.setState({
            noticeshow : false
        })
    //   console.log(this.state.noticeshow);
    }.bind(this), 4000);
 }


  handleChange = (moment) => {
    this.setState({
      moment
    });
    // console.log("data--===>time", this.state.moment._d)
  }


  closeTicket=(event)=>{
    event.preventDefault()
    this.setState({
      ticket : false
    })

  }
 
  render() {
    
      let {imagePreviewUrl} = this.state;
      let $imagePreview = null;
      if (imagePreviewUrl) {
        $imagePreview = (<img src={imagePreviewUrl} />);
      } else {
        $imagePreview = (<div className="previewText">Please select an Image for Preview</div>);
      }
      const shortcuts = {
        'Today': moment(),
        'Yesterday': moment().subtract(1, 'days'),
        'Clear': ''
      };
  
    return (
      
      this.state.submitIftrue ? (
                                
        <Redirect to={{    pathname: `${'/info'}`  }}/>

        ):
          !this.props.isAuthenticated ? (
              <div className="hero is-bold is-fullheight">
              <div className="level-item">
              <a className="button is-loading is-large is-light">Loading</a>
              </div>
              <div className="level-item">
              <span>Trying to login...</span>
              </div>
          </div>
            )
              :
              <div className="event-body-page-body-full">
                    <div className="Activity-moble-nav-body">
                        < Moble  logout={this.logout} isActiveE={this.state.isActive}/>
                    </div>     
                        <SideNav vanImage={this.props.organizer.image_url}  email={this.props.user.email} 
                        logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name} 
                        organizers404={this.props.organizers404} isActiveE={this.state.isActive}
                        /> 

                    <div className="main"> 
                        <div className="topright">
                            {
                                this.state.noticeshow ?
                                <div className="notice-cos-tuition">
                                    {this.state.noticeMassage}
                                </div> :
                                <span> </span> 
                            }
                          </div>
                           <div className="event-body-page-body">
                                <div className="tabs is-boxed">
                                  <ul>
                                    {/* <li className="is-active"> */}
                                    <li className={(!this.state.ticket  ? 'is-active' : '')}>
                                    
                                      <a onClick={this.closeTicket}>
                                        <span className="icon is-small"><i className=" fab fa-wpforms icon-link"></i></span>
                                        <b> <span>Form</span>  </b>
                                      </a>
                                    </li>
                                    <li className={(this.state.ticket  ? 'is-active' : '')}>
                                      <a  onClick={this.showTicket}>
                                        <span className="icon is-small"><i className="fas fa-ticket-alt" aria-hidden="true"></i></span>
                                       <b> <span>Ticket</span></b>  
                                      </a>
                                    </li>
                                    
                                  </ul>
                                </div>
                                {
                                    this.state.ticket ?
                                    <div className="is-boxed-event-body-page-body">
                                      <b> <i className="fas fa-ticket-alt" aria-hidden="true"></i> Ticket  </b>   
                                     <form onSubmit={this._handleSubmit}>
                                    <div className="field  field-input-event-style">
                                       <label className="label">Name</label>
                                       <div className="control">
                                         <input className="input" ref={input => this.name = input} type="text" placeholder=" Name" required/>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Amount</label>
                                       <div className="control">
                                         <input className="input" type="number" ref={input => this.amount = input}   placeholder=" Amount" required/>
                                       </div>
                                     </div>
                                     <div className="field field-input-event-style">
                                       <label className="label">Event Description</label>
                                       <div className="control">
                                         <textarea className="textarea" ref={input => this.description = input} placeholder="Description" required></textarea>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Event Location</label>
                                       <div className="control">
                                         <input className="input"  ref={input => this.valueTK = input} type="text" placeholder="Location" required/>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Starts At</label>
                                       <div className="control">
                                        <DatetimePickerTrigger
                                            shortcuts={shortcuts} 
                                            moment={this.state.moment}
                                            onChange={this.handleChange}>
                                            <input type="text" className="input" value={this.state.moment.format('YYYY-MM-DD HH:mm')} readOnly  required/>
                                          </DatetimePickerTrigger>
                                       </div>
                                     </div>
                                   
                                     <div className="previewComponent">
                                       <div className="imgPreview">
                                             {$imagePreview}
                                           </div>
 
                                               <div className="field" style={{"position":"relative","left":"15px"}}>
                                                 <div className="file is-small">
                                                   <label className="file-label">
                                                     <input className="file-input"  type="file"  onChange={this._handleImageticket} name="resume" required/>
                                                     <span className="file-cta">
                                                       <span className="file-icon">
                                                         <i className="fas fa-upload"></i>
                                                       </span>
                                                       <span className="file-label">
                                                         Image file…
                                                       </span>
                                                     </span>
                                                   </label>
                                                 </div>
                                               </div>
                                      </div>
                                     <hr/>
                                     <div className="field is-grouped event-submit-button">
                                       <div className="control">
                                         <button className="button is-link">Next</button>
                                       </div>
                                       
                                     </div>
                                     </form>
                                     <br/>
                                   <br/>
                                   <br/>
                                   <br/>
                              </div>
                              :
                              
                              <div className="is-boxed-event-body-page-body">
                                  <b> <i className=" fab fa-wpforms icon-link"></i>  Form  </b>  
                                  <form onSubmit={this._handleSubmitform}>
                                    <div className="field  field-input-event-style">
                                       <label className="label">Name</label>
                                       <div className="control">
                                         <input className="input" ref={input => this.name = input} type="text" placeholder="Name" required/>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Amount</label>
                                       <div className="control">
                                         <input className="input" type="number" ref={input => this.amount = input}   placeholder=" Amount" required/>
                                       </div>
                                     </div>
                                     <div className="field field-input-event-style">
                                       <label className="label">Event Description</label>
                                       <div className="control">
                                         <textarea className="textarea" ref={input => this.description = input} placeholder=" Description" required></textarea>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Event Location</label>
                                       <div className="control">
                                         <input className="input"  ref={input => this.valueTK = input} type="text" placeholder=" Location" required/>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Starts At</label>
                                       <div className="control">
                                        <DatetimePickerTrigger
                                            shortcuts={shortcuts} 
                                            moment={this.state.moment}
                                            onChange={this.handleChange}>
                                            <input type="text" className="input" value={this.state.moment.format('YYYY-MM-DD HH:mm')} readOnly  required/>
                                          </DatetimePickerTrigger>
                                       </div>
                                     </div>
                                   
                                     <div className="previewComponent">
                                       <div className="imgPreview">
                                             {$imagePreview}
                                           </div>
                                         
                                             {/* <input className="fileInput" 
                                               type="file" 
                                               onChange={(e)=>this._handleImageChange(e)} /> */}

                                               <div className="field" style={{"position":"relative","left":"15px"}}>
                                                 <div className="file is-small">
                                                   <label className="file-label">
                                                     <input className="file-input"  type="file"  onChange={(e)=>this._handleImageChange(e)} name="resume" required/>
                                                     <span className="file-cta">
                                                       <span className="file-icon">
                                                         <i className="fas fa-upload"></i>
                                                       </span>
                                                       <span className="file-label">
                                                         Image file…
                                                       </span>
                                                     </span>
                                                   </label>
                                                 </div>
                                               </div>
                                             
                                         
                                        </div>
                                     <hr/>
                                     <div className="field is-grouped event-submit-button">
                                        {
                                          this.state.loading ?
                                              <div className="level-item">
                                                  <a className="button is-loading is-large is-light">Loading</a>
                                              </div>
                                          :
                                            <div className="control">
                                                <button className="button is-link">Next</button>
                                            </div>
                                        }
                                       
                                       
                                     </div>
                                     </form>
                                     <br/>
                                   <br/>
                                   <br/>
                              </div>
                                }
                               
                          </div>
                      </div>
              </div>
          )

}





}

export default Eventcreate;


// WEBPACK FOOTER //
// ./src/component/create/event.js